import { useContext } from "react";
import { useSelector } from "react-redux";
import { Calendar, CalendarFilter } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  calendar: Calendar;
  retrieveCalendar(request: Boundaries["retrieveCalendar"]["request"]): void;
}

function useRetrieveCalendar(filter: CalendarFilter): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveCalendarRequestPending(filter),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveCalendarRequestSuccess(filter),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveCalendarRequestFailure(filter),
    ),
    calendar: useSelector(() => selector.getCalendar(filter)),
    retrieveCalendar: core.retrieveCalendar,
  };
}

export { useRetrieveCalendar };
